<template minapp='mpx' xlang='wxml'>
  <view class="es-custom-class" wx:class="{{classname}}">
    <slot></slot>
  </view>
</template>
<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  createComponent({
    props: {
      shake: {
        type: Boolean,
        value: false
      }
    },

    data: {
      status: false
    },

    watch: {
      //   show: {
      //     immediate: true,
      //     handler(val, old) {
      //       if (val === old) {
      //         return
      //       }
      //       this.run(val)
      //     }
      //   }
    },

    computed: {
      classname() {
        return {
          'es-tran-shake': this.shake
        }
      }
    },

    methods: {
      onClick() {
        this.$trigger('click')
      },

      enter() {
        return ['enter', this.setActive, 'enter-to']
      },

      leave() {
        return ['leave', this.setCancel, 'leave-to']
      },

      run(value) {
        return nextFrame.mapInFrames(value ? this.enter() : this.leave(), status =>
          this.setStatus(status)
        )
      }
    }
  })
</script>
<style lang='stylus' scoped>
  .es-tran-shake
    animation shake 800ms ease-in-out
  @keyframes shake
    /* 动画需：“对称”实现 */
    10%, 90%
      transform translate3d(-1px, 0, 0)
    20%, 80%
      transform translate3d(+2px, 0, 0)
    30%, 70%
      transform translate3d(-4px, 0, 0)
    40%, 60%
      transform translate3d(+4px, 0, 0)
    50%
      transform translate3d(-4px, 0, 0)
</style>
<script name='json'>
  const config = {
    usingComponents: {}
  }
  module.exports = config
</script>